module.exports = __webpack_public_path__ + "models/hub_cd7d96987aedbc288adbb85debf9877b.glb";